import React from 'react';

import Tile from '@atlaskit/tile';

export default function TileDefault(): React.JSX.Element {
	return <Tile label="" />;
}
